import { FormProvider } from "react-hook-form";

import { SchemaBaseEditor } from "src/entities/SchemaEditor/SchemaBaseEditor";
import { SchemaPropertiesEditor } from "src/entities/SchemaEditor/SchemaPropertiesEditor";
import { useUpdateEntitySchema } from "src/entities/queries";
import { useSchemaEditor } from "src/entities/useSchemaEditor";
import { SchemaEditorSidebar } from "src/schema/schemaEditor/SchemaEditorSidebar";
import { EntitySchemaFormData } from "src/schema/schemaEditor/types";
import { useSchemaForm } from "src/schema/schemaEditor/useSchemaForm";

type EntitySchemaEditorSidebarProps = {
  schema: EntitySchemaFormData;
};

export const EntitySchemaEditorSidebar: React.FC<
  EntitySchemaEditorSidebarProps
> = ({ schema }) => {
  const { mutateAsync: updateSchema } = useUpdateEntitySchema();
  const [, toggleSchemaEditor] = useSchemaEditor();

  const { form, handleSubmit, isSaving, canSave } = useSchemaForm(
    schema,
    async (data) => {
      const result = await updateSchema(data);
      return result as EntitySchemaFormData;
    },
  );

  const onSubmit = form.handleSubmit(handleSubmit);

  return (
    <form className="h-full" onSubmit={onSubmit}>
      <FormProvider {...form}>
        <SchemaEditorSidebar
          canSave={canSave}
          isSaving={isSaving}
          schema={schema}
          title="Edit Entity schema"
          tooltipText="For additional changes you want to make to the Entity Schema, please contact the Taktile team."
          onClose={toggleSchemaEditor}
        >
          <div className="flex h-full flex-col gap-y-4">
            <SchemaBaseEditor isLoading={false} />
            <SchemaPropertiesEditor isLoading={false} />
          </div>
        </SchemaEditorSidebar>
      </FormProvider>
    </form>
  );
};
